import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { SearchClientForVendorPayload } from "../../payload/SearchClientForVendor/SearchClientForVendorPayload";

const searchClientForVendorFetch = (state: ClientsState, action: PayloadAction<SearchClientForVendorPayload>) => {
    state.isLoading = false;
}

export default searchClientForVendorFetch;